import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex);
const state = {
    loginState:null,
    isLogin:false,
    tokenAuth:null,
    drawer:true,

};

const store = new Vuex.Store({
    state,

    getters:{
        loginState: (state)=>{
            return state.loginState;
        },
        gLogin: (state)=>{
            return state.isLogin;
        },
        DRAWER_STATE(state) {
            return state.drawer;
          }
      
    },
    actions:{
        loginState(context,loginState){
            context.commit('loginState',loginState)
        },
        aLogin(context){
            context.commit('mLogin')
        },
        aLogout(context){
            context.commit('mLogout')
        },
        TOGGLE_DRAWER({ commit }) {
            commit('toggleDrawer');
          }
      

    },
    mutations:{
        loginState(state,loginState){
            state.loginState = loginState;
        },
        mLogin(state){
            state.isLogin = true;
            state.tokenAuth = localStorage.getItem('token_auth');
        },
        mLogout(state){
            state.isLogin = false;
            state.tokenAuth = null;
        },
        mReset(state){
            state.isLogin = false;
        },
        toggleDrawer(state) {
            state.drawer = !state.drawer;
          }
      

    },
    plugins:[createPersistedState()]
});

export default store;

